<template>
  <div>
    <filter-slot
      :filter="filters"
      :filter-principal="filterPrincipal"
      :total-rows="totalRows"
      :paginate="paginate"
      @reload="$refs['ref-table-users-list'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-users-list"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          :sort-desc.sync="sortDesc"
          primary-key="id"
          :empty-text="$t('NO MATCHING RECORDS FOUND')"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-1" />
              <strong v-t="'LOADING...'"></strong>
            </div>
          </template>
          <template #cell(full_name)="data">
            <router-link
              :class="[textLink]"
              :to="{
                name: 'user-edit',
                params: {
                  id: data.item.id,
                },
              }"
              >{{ data.item.full_name }}</router-link
            >
            <br />
            <feather-icon
              icon="CircleIcon"
              size="13"
              style="border-radius: 50%; margin-bottom: 2px; margin-right: 5px"
              :style="
                data.item.status_session == 1
                  ? 'background:green; color: green; border-color: green;'
                  : data.item.status_session == 2
                  ? 'background:orange; color: orange; border-color: orange;'
                  : data.item.status_session == 3
                  ? 'background:red; color: red; border-color: red;'
                  : 'background:#ccc; color: #ccc; border-color: #ccc;'
              "
            />
            <span>
              {{
                $t(
                  data.item.status_session == 1
                    ? "Active"
                    : data.item.status_session == 2
                    ? "Busy"
                    : data.item.status_session == 3
                    ? "Away"
                    : "Offline"
                )
              }}
            </span>
          </template>
          <template #cell(email)="data">
            <span> {{ data.item.email }} </span>
          </template>
          <template #cell(type)="data">
            <span> {{ $t(data.item.type) | capitalize }} </span> <br />
          </template>
          <template #cell(campus)="data">
            <div class="row align-items-center">
              <span>{{ data.item.campus }}</span>
            </div>
          </template>
          <template #cell(is_ceo)="data">
            <span> {{ data.item.is_ceo ? $t("YES") : "NO" }} </span>
          </template>
          <template #cell(status)="data">
            <b-badge
              pill
              :variant="data.item.status ? 'light-success' : 'light-warning'"
              class="text-capitalize"
            >
              <span>
                {{
                  data.item.status ? $t("ACTIVE") : $t("INACTIVE") | capitalize
                }}</span
              >
            </b-badge>
          </template>
          <template #cell(actions)="data">
            <div class="d-flex justify-content-center">
              <feather-icon
                :id="'change-password-'+data.item.id"
                icon="LockIcon"
                size="15"
                class="text-primary cursor-pointer"
                @click="showModalResetPassword(data.item)"
              />
            </div>
          </template>
        </b-table>
      </template>
    </filter-slot>
    <ResetPasswordModal
      ref="reset-password-modal"
      v-if="showResetPassword"
      :user="userSelected"
      @close="closeResetPassword"
    />
  </div>
</template>
  
  <script>
/* SERVICES */
import { mapGetters } from "vuex";

/* DATA */
import Fields from "@/views/users/views/list/data/Fields.data";
import Filters from "@/views/users/views/list/data/Filters.data";

/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import UserServices from "@/views/users/services/users.service";
import ResetPasswordModal from "@/views/users/views/list/components/ResetPasswordModal.vue";

export default {
  name: "UserList",
  components: {
    FilterSlot,
    ResetPasswordModal,
  },
  data() {
    return {
      startPage: 0,
      userSelected: {},
      showResetPassword: false,
      toPage: 0,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      totalRows: 0,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      paginate: {
        currentPage: 1,
        perPage: 10,
      },

      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
    };
  },
  methods: {
    async myProvider(ctx) {
      try {
        let params = {
          from: this.filters[0].model,
          to: this.filters[1].model,
          npage: ctx.currentPage,
          perpage: ctx.perPage,
          name_text: this.filterPrincipal.model,
          orderby: ctx.sortDesc ? "desc" : "asc",
          // order: null,
        };
        const { data } = await UserServices.getUsers(params);
        this.paginate.currentPage = data.current_page;
        this.paginate.perPage = data.per_page;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.from = data.from;

        return data.data || [];
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    showModalResetPassword(data) {
      this.userSelected = { ...data };
      this.showResetPassword = true;
    },
    closeResetPassword() {
      this.showResetPassword = false;
    },

    refreshTable() {
      this.$refs["ref-table-users-list"].refresh();
    },
  },

  computed: {
    fields() {
      return Fields.map((element) => ({
        ...element,
        label: this.$t(element.label),
      }));
    },

    filters() {
      return Filters;
    },
  },
};
</script>
    
    
    